import { useQuery } from '@tanstack/react-query';
import { API } from '@src/api/index.ts';
import { EntityByIdParam } from '@src/api/types.ts';

export const useCoachVideoQuery = (params: EntityByIdParam) => {
  return useQuery({
    queryKey: ['coach_video', params.id],
    queryFn: async () => await API.coaches.getPresentVideo(params),
    enabled: typeof params?.id !== 'undefined',
  });
};
